const searchQuery = (post, term) => {
    if (term === "" || !term) {
        return false;
    }

    return (
        (post.title && post.title.toLowerCase().includes(term.toLowerCase())) ||
        (post.custom_excerpt &&
            post.custom_excerpt.toLowerCase().includes(term.toLowerCase())) ||
        (post.html && post.html.toLowerCase().includes(term.toLowerCase()))
    );
};

const removeHash = (name) => {
    if (name.charAt(0) === "#") {
        return name.substring(1, name.length);
    }

    if (name.substring(0, 5) === "hash-") {
        return name.substring(5, name.length);
    }

    return name;
};

const getSearchList = (posts, term) => {
    let allPosts = [];

    posts.forEach((post) => {
        if (searchQuery(post.node, term)) {
            allPosts.push(post);
        }
    });

    return allPosts;
};

const getPostList = (posts, filter, industry, country, slug) => {
    let allPosts = [];

    posts.forEach(({ node }) => {
        let hasCountry = Object.keys(node.tags).some(
            (k) =>
                removeHash(
                    node.tags[k].name.toLowerCase().replace(" ", "-")
                ) === `${removeHash(country.toLowerCase().replace(" ", "-"))}`
        );
        let hasIndustry = Object.keys(node.tags).some(
            (k) =>
                removeHash(
                    node.tags[k].name.toLowerCase().replace(" ", "-")
                ) === `${removeHash(industry.toLowerCase().replace(" ", "-"))}`
        );

        let hasFilter = Object.keys(node.tags).some(
            (k) =>
                removeHash(
                    node.tags[k].name.toLowerCase().replace(" ", "-")
                ) === `${removeHash(filter.toLowerCase().replace(" ", "-"))}`
        );

        let isSlug = Object.keys(node.tags).some(
            (k) =>
                removeHash(
                    node.tags[k].name.toLowerCase().replace(" ", "-")
                ) === slug
        );

        if (isSlug) {
            const data = getPosts(
                country,
                hasCountry,
                industry,
                hasIndustry,
                filter,
                hasFilter,
                node
            );

            if (data) {
                allPosts.push(data);
            }
        }
    });

    return allPosts;
};

const getPosts = (
    country,
    hasCountry,
    industry,
    hasIndustry,
    filter,
    hasFilter,
    node
) => {
    if (
        industry !== "" &&
        hasIndustry &&
        (country === "" || country.toLowerCase() === "all") &&
        (filter === "" || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (industry.toLowerCase() === "all" || industry === "") &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all") &&
        ((filter !== "" && hasFilter) || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (industry.toLowerCase() === "all" || industry === "") &&
        (country === "" || country.toLowerCase() === "all") &&
        ((filter !== "" && hasFilter) || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (industry.toLowerCase() === "all" || industry === "") &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all") &&
        (filter === "" || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (industry.toLowerCase() === "all" || industry === "") &&
        (country === "" || country.toLowerCase() === "all") &&
        (filter === "" || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        industry !== "" &&
        hasIndustry &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all") &&
        ((filter !== "" && hasFilter) || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        country !== "" &&
        hasCountry &&
        (industry === "" || industry.toLowerCase() === "all") &&
        (filter === "" || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (country.toLowerCase() === "all" || country === "") &&
        ((industry !== "" && hasIndustry) ||
            industry.toLowerCase() === "all") &&
        ((filter !== "" && hasFilter) || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (country.toLowerCase() === "all" || country === "") &&
        (industry === "" || industry.toLowerCase() === "all") &&
        ((filter !== "" && hasFilter) || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (country.toLowerCase() === "all" || country === "") &&
        ((industry !== "" && hasIndustry) ||
            industry.toLowerCase() === "all") &&
        (filter === "" || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (country.toLowerCase() === "all" || country === "") &&
        (industry === "" || industry.toLowerCase() === "all") &&
        (filter === "" || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        country !== "" &&
        hasCountry &&
        ((industry !== "" && hasIndustry) ||
            industry.toLowerCase() === "all") &&
        ((filter !== "" && hasFilter) || filter.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        filter !== "" &&
        hasFilter &&
        (industry === "" || industry.toLowerCase() === "all") &&
        (country === "" || country.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (filter.toLowerCase() === "all" || filter === "") &&
        ((industry !== "" && hasIndustry) ||
            industry.toLowerCase() === "all") &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (filter.toLowerCase() === "all" || filter === "") &&
        (industry === "" || industry.toLowerCase() === "all") &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (filter.toLowerCase() === "all" || filter === "") &&
        ((industry !== "" && hasIndustry) ||
            industry.toLowerCase() === "all") &&
        (country === "" || country.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (filter.toLowerCase() === "all" || filter === "") &&
        (industry === "" || industry.toLowerCase() === "all") &&
        (country === "" || country.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        filter !== "" &&
        hasFilter &&
        ((industry !== "" && hasIndustry) ||
            industry.toLowerCase() === "all") &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        filter !== "" &&
        hasFilter &&
        (country === "" || country.toLowerCase() === "all") &&
        (industry === "" || industry.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (filter.toLowerCase() === "all" || filter === "") &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all") &&
        ((industry !== "" && hasIndustry) || industry.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (filter.toLowerCase() === "all" || filter === "") &&
        (country === "" || country.toLowerCase() === "all") &&
        ((industry !== "" && hasIndustry) || industry.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (filter.toLowerCase() === "all" || filter === "") &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all") &&
        (industry === "" || industry.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        (filter.toLowerCase() === "all" || filter === "") &&
        (country === "" || country.toLowerCase() === "all") &&
        (industry === "" || industry.toLowerCase() === "all")
    ) {
        return node;
    } else if (
        filter !== "" &&
        hasFilter &&
        ((country !== "" && hasCountry) || country.toLowerCase() === "all") &&
        ((industry !== "" && hasIndustry) || industry.toLowerCase() === "all")
    ) {
        return node;
    } else {
        return null;
    }
};

const createPostFeedsCount = (
    posts,
    term = false,
    postLength = 4,
    search = false,
    filter = "",
    industry = "",
    country = "",
    slug = "",
    maxPosts = 7,
) => {
    let onlyPosts = null;

    if (search) {
        onlyPosts = getSearchList(posts, term);
    } else {
        onlyPosts = getPostList(posts, filter, industry, country, slug);
    }

    if (onlyPosts && onlyPosts.length === 0) {
        return false;
    }

    let onlyPostLength = Math.ceil(onlyPosts.length / maxPosts);
    let maxLength = onlyPostLength < postLength ? onlyPostLength : postLength;

    if (slug === "noissue-101" || slug === "biz-advice") {
        onlyPostLength = Math.ceil(onlyPosts.length / 4);
        maxLength = onlyPostLength < postLength ? onlyPostLength : postLength;
    }
    if(slug === 'inspo')
        return onlyPosts.length;

    if (maxLength < onlyPostLength) {
        return true;
    } else {
        return false;
    }
};

export default createPostFeedsCount;
